<!-- eslint-disable vue/no-v-html -->
<template>
  <NuxtLayout>
    <q-page
      padding
      class="column justify-center items-center q-gutter-y-md"
    >
      <div>
        <h1
          class="text-weight-medium no-margin"
          style="line-height: 1;"
        >
          {{ error.status }}
        </h1>
      </div>
      <div
        class="text-h5 text-grey"
        style="overflow-wrap: anywhere; word-break: break-word;"
      >
        {{ error.message }}
      </div>
      <q-card
        v-if="showStack"
        class="scroll"
        style="max-width: 90%;  max-height: 300px;"
        flat
      >
        <pre
          class="q-pa-sm no-margin"
          style="line-height: 1.35;"
          v-html="error.stack"
        />
      </q-card>
      <div>
        <div class="row flex-center q-gutter-md">
          <q-btn
            v-if="error.status == 401"
            color="primary"
            size="lg"
            padding="sm xl"
            label="Login"
            @click="dialog({ component: LazyDialogAuthLoginRegister })
              .onOk(() => navigateTo(route.fullPath))"
          />
          <q-btn
            v-else-if="error.status == 429"
            color="primary"
            size="lg"
            padding="sm xl"
            label="Reload Page"
            @click="reload()"
          />
          <q-btn
            v-else
            href="/"
            color="primary"
            size="lg"
            padding="sm xl"
            label="Continue Shopping"
          />
        </div>
      </div>
    </q-page>
  </NuxtLayout>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app';
import { LazyDialogAuthLoginRegister } from '#components';

const props = defineProps({
  error: {
    required: true,
    type: Object as PropType<NuxtError>,
  },
});

const { dialog } = useQuasar();

const route = useRoute();

const showStack = computed(() => import.meta.dev && !!props.error.stack);

const reload = () => window.location.reload();

useSeoMeta({
  title: props.error.message ?? props.error.statusMessage ?? 'Unknown',
  titleTemplate: '%s %separator Error',
});

onMounted(async () => {
  await nextTick();

  // Scroll to top on client-side
  window.scrollTo({ top: 0, behavior: 'auto' });
});
</script>
